module.exports = __webpack_public_path__ + "static/media/place-localizer-ico.9da47e05.svg";